module.exports = __webpack_public_path__ + "static/media/42-10.90f0ac52.mp3";